import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrintingList, PrintingQuery, printingListResponseSchema, printingQuerySchema } from '../models/printing.model';

@Injectable({ providedIn: 'root' })
export class PrintingService {
  private _http = inject(HttpClient);

  private readonly route: Record<keyof PrintingQuery, string> = {
    ids: 'ids',
    modelIds: 'model-ids',
    userIds: 'user-ids',
    adminIds: 'admin-ids',
    startDate: 'start-date',
    endDate: 'end-date',
    offset: 'offset',
    limit: 'limit',
    exclude: 'exclude',
  };

  getPrintingList(query: PrintingQuery = {}): Observable<PrintingList> {
    return defer(() => {
      const parsedQuery = printingQuerySchema.parse(query);
      let parameters = new HttpParams();

      for (const key of Object.keys(parsedQuery) as (keyof PrintingQuery)[]) {
        const parameter = parsedQuery[key];
        if (parameter === undefined) continue;
        if (Array.isArray(parameter)) {
          parameter.forEach((value, index) => {
            parameters = parameters.append(`${this.route[key]}[${index}]`, String(value));
          });
          continue;
        }

        parameters = parameters.set(this.route[key], String(parameter));
      }

      return this._http
        .get<unknown>('/api/printings/list', { params: parameters })
        .pipe(map(response => printingListResponseSchema.parse(response).data));
    });
  }
}
